//
// # EditorCore Namespace
//
// The primary `Editor` class, all drawing and associated logic.
//

import "./css"; // All side effects here, modifying `document` styling

// Export the primary schematic-editor class
export { Editor } from "./editor";

// Platform interfaces
export {
  Platform,
  PlatformError,
  SelectionInfo,
  NullPlatform,
} from "EditorCore/src/platform";
export type { FieldEdits } from "EditorCore/src/content/fieldEdits";
export { PlatformTransport } from "./transport";
export { MessagePlatform } from "./message_platform";

// Start helper
export { start } from "./start";

// Keyboard utilities
export {
  isTextInputFocused,
  isMac,
  hasPlatformCmdModifier,
} from "EditorCore/src/keys";

// Entity types
export { EntityKind } from "DrawCore/src/entity";

// Symbol graphics catalogue
export { CATALOGUE as GraphicsCatalogue } from "DrawCore/src/content/symbol";
export type { CatalogueEntry as GraphicsCatalogueEntry } from "DrawCore/src/content/symbol";

// Validation utilities
export { isValidPinName, PIN_NAME_PATTERN } from "DrawCore/src/validation";

// Layer utilities for IDE panel
export {
  getLayersToDisplay,
  groupLayersByCategory,
} from "DrawCore/src/layer_utils";
export type { LayoutContent } from "EditorCore/src/content/layout/content";
export type { Schematic } from "EditorCore/src/content/schematic/schematic";
// Content kind discriminant ("schematic" | "symbol" | "layout" | "graphics"),
// surfaced for IDE context classification.
export type { ContentKind } from "DrawCore/src/content/kind";

// Display options for IDE panels
export {
  LayoutDisplayOptions,
  SchematicDisplayOptions,
  LayoutSelectability,
  SchematicSelectability,
} from "DrawCore/src/draw/drawto";

// Theme
export { Theme } from "DrawCore/src/style/theme";
export type { Theme as ThemeType } from "DrawCore/src/style/theme";
export { applyThemeToDom } from "./theme_dom";

// SRV (Schematic Rules Validation) types — the rule engine and the rule
// descriptor list both run on the Rust tool server; the IDE fetches the
// descriptors via AlphaServer (see workspace.requestSrvRules). The shared wire
// types live in GenAlphaModel's `srv` namespace and are surfaced here.
export type {
  SrvRuleDescriptor,
  SrvViolation,
  SrvRunResult,
} from "GenAlphaModel/src/srv/types";
export type { SrvOverlay } from "DrawCore/src/content/schematic/srv_arrows";
